/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBook = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 19H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5a4.99 4.99 0 0 1 4 2 4.991 4.991 0 0 1 3.743-1.994L16 2h5a1 1 0 0 1 .993.883L22 3v15a1 1 0 0 1-.883.993L21 19h-6a2 2 0 0 0-1.995 1.85L13 21a1 1 0 0 1-2 0 2 2 0 0 0-2-2zM8 4H4v13h5c.729 0 1.412.195 2 .535V7a3 3 0 0 0-3-3zm12 0h-4a3 3 0 0 0-2.995 2.824L13 7v10.535a3.976 3.976 0 0 1 1.729-.526L15 17h5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBook as Book };
